/**
 * 
 */

import React from 'react';

const ProgressBar = ( props ) => {
  const { completed } = props;
  
  const containerStyles = {
    height: 4,
    width: '100%',
    backgroundColor: "#BDCAEB",
    borderRadius: 4
  }

  const fillerStyles = {
    height: '100%',
    width: `${completed}%`,
    backgroundColor: "#F46F21",
    borderRadius: 'inherit',
    transition: 'width 1s ease-in-out',
    textAlign: 'right'
  }

  const labelStyles = {
    padding: 2,
    color: 'white',
    fontWeight: 'bold'
  }

  let classes = "progress-bar horisontal";
  if( typeof props.className != 'undefined' ){
    classes = classes + ' ' + props.className ;
  }

  return (
    <div style={containerStyles} class={classes}>
      <div style={fillerStyles}>
        <span style={labelStyles}>{`${completed}%`}</span>
      </div>
    </div>
  );
};

export default ProgressBar; 